/**
 * AML Screening Reducer
 * Manages state for Veriff AML watchlist screening
 */

const initialState = {
    isLoading: false,
    primaryOwner: null,
    beneficialOwners: {},
    error: null,
    lastScreenedAt: null
};

function aml(state = initialState, action) {
    switch (action.type) {
        // Primary Owner Screening
        case 'AML_SCREEN_PRIMARY_REQUEST':
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case 'AML_SCREEN_PRIMARY_SUCCESS':
            return {
                ...state,
                isLoading: false,
                primaryOwner: {
                    sessionId: action.data.sessionId,
                    matchStatus: action.data.matchStatus,
                    hits: action.data.hits,
                    screenedAt: action.data.screenedAt
                },
                lastScreenedAt: action.data.screenedAt,
                error: null
            };

        case 'AML_SCREEN_PRIMARY_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: action.error
            };

        // Beneficial Owner Screening
        case 'AML_SCREEN_BENEFICIAL_REQUEST':
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case 'AML_SCREEN_BENEFICIAL_SUCCESS':
            return {
                ...state,
                isLoading: false,
                beneficialOwners: {
                    ...state.beneficialOwners,
                    [action.ownerIndex]: {
                        sessionId: action.data.sessionId,
                        matchStatus: action.data.matchStatus,
                        hits: action.data.hits,
                        screenedAt: action.data.screenedAt
                    }
                },
                lastScreenedAt: action.data.screenedAt,
                error: null
            };

        case 'AML_SCREEN_BENEFICIAL_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: action.error
            };

        // Set results from loaded KYC data
        case 'AML_SET_RESULTS':
            if (!action.data) {
                return initialState;
            }
            return {
                ...state,
                primaryOwner: action.data.primaryOwner || null,
                beneficialOwners: action.data.beneficialOwners || {},
                lastScreenedAt: action.data.lastScreenedAt || null,
                isLoading: false,
                error: null
            };

        // Clear results
        case 'AML_CLEAR_RESULTS':
            return initialState;

        // Loading states
        case 'AML_SET_LOADING':
            return {
                ...state,
                isLoading: true
            };

        case 'AML_SET_NOT_LOADING':
            return {
                ...state,
                isLoading: false
            };

        default:
            return state;
    }
}

export default aml;
